import { apiURL } from "../../config";

export async function getSearchResult(axiosPrivate, searchPhrase, id = false, searchFilters) {
	let filters = "";
	Object.keys(searchFilters).forEach((filter) => {
		if (Array.isArray(searchFilters[filter]) && searchFilters[filter].length > 0)
			filters += `&${filter}=${searchFilters[filter].map((option) => option)}`;
		else if (!Array.isArray(searchFilters[filter])) {
			filters += `&${filter}=${searchFilters[filter]}`;
		}
		return;
	});

	return axiosPrivate
		.get(
			`${apiURL}/decision/receiver/search.json?${searchPhrase ? `&phrase=${searchPhrase}` : ""}${id ? "&exclude=" + id : ""}${
				filters ? filters : ""
			}`
		)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getSearchFilters(axiosPrivate) {
	return axiosPrivate
		.get(`${apiURL}/decision/receiver/search-filter.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}
